<template>
  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">
      <div class="row w-100">
        <!-- <div  :class="{ 'p-list-representation-error': $v.formData.club.name.$error }"  class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
                <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
                  نام
                </label>
                <input v-model="formData.club.name" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div> -->

        <!-- <div  :class="{ 'p-list-representation-error': $v.formData.club.family.$error }"  class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
                <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
                  نام و نام خانوادگی
                </label>
                <input v-model="formData.club.family" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div> -->

        <div
          :class="{ 'p-list-representation-error': $v.formData.name.$error }"
          class="d-flex align-items-center mb-4  p-edit-representation-form-item"
        >
          <label
            class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text"
          >
            نام سالن
          </label>
          <input
            v-model="formData.name"
            type="text"
            placeholder=""
            class="form-control text-right col-lg-8 pr-3 pl-2 pr-2"
          />
        </div>

        <!-- <div :class="{ 'p-list-representation-error': $v.formData.phone.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                شماره تماس مجموعه
              </label>
              <input v-model="formData.phone" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div> -->

        <!-- <div :class="{ 'p-list-representation-error': $v.formData.shaba_code.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                شماره شبا
              </label>
              <input v-model="formData.shaba_code" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div> -->

        <!-- <div  :class="{ 'p-list-representation-error': $v.formData.club.bank_name.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                نام بانک
              </label>
              <input v-model="formData.club.bank_name" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div> -->

        <div
          :class="{ 'p-list-representation-error': $v.formData.address.$error }"
          class="d-flex align-items-center mb-4  p-edit-representation-form-item"
        >
          <label
            class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text"
          >
            آدرس
          </label>
          <input
            v-model="formData.address"
            type="text"
            placeholder=""
            class="form-control text-right col-lg-8 pr-3 pl-2 pr-2"
          />
        </div>

        <!-- <div :class="{ 'p-list-representation-error': $v.formData.club.name.$error }"  class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                نام سالندار
              </label>
              <input v-model="formData.club.name" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div>

            <div :class="{ 'p-list-representation-error': $v.formData.club.family.$error }"  class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                نام خانوادگی سالندار
              </label>
              <input v-model="formData.club.family" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
            </div> -->

        <!-- <div class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
              <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
                نام و نام خانوادگی سالندار
              </label>
              <multiselect
               v-model="formData.valueSelectedNameFamilySalondar"
               :options="nameFamilySalondar"
               placeholder='یکی از نام های سالندار را انتخاب کنید'
               label="title"
               track-by="title"
               :show-labels="false"
               :allow-empty="false"
               class="col-lg-8"
               >
               </multiselect>
            </div> -->

        <div class="w-100 row">
          <div
            :class="{
              'p-list-representation-error': $v.formData.content.$error
            }"
            class="d-flex align-items-center mb-4  p-edit-representation-form-item"
          >
            <label
              class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text "
            >
              توضیحات
            </label>
            <textarea
              v-model="formData.content"
              class="form-control col-lg-8 pr-3 pl-3 pt-2 pb-2"
              rows="4"
            ></textarea>
          </div>
        </div>

        <toolsSalon
          @initialConvertArrayFacilities="initialConvertArrayFacilities"
          @changeCheckBox="changeTools"
          :all-enums="allEnums"
          :form-data="formDataOriginal"
        ></toolsSalon>

        <typeUser
          @initialConvertArrayUsingType="initialConvertArrayUsingType"
          @changeCheckBox="changeType"
          :all-enums="allEnums"
          :form-data="formDataOriginal"
        ></typeUser>
      </div>

      <div class="row w-100 mt-0 mt-lg-2 mb-5">
        <div
          :class="{
            'p-list-representation-error': $v.formData.sans_price.$error
          }"
          class="d-flex align-items-center mb-4  p-edit-representation-form-item"
        >
          <label
            class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text"
          >
            مبلغ سانس
          </label>
          <input
            v-model="formData.sans_price"
            type="text"
            placeholder=""
            class="form-control text-right col-lg-8 pr-3 pl-2 pr-2"
          />
        </div>

        <div
          :class="{
            'p-list-representation-error': $v.formData.sans_beyane_price.$error
          }"
          class="d-flex align-items-center mb-4  p-edit-representation-form-item"
        >
          <label
            class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text"
          >
            مبلغ بیعانه
          </label>
          <input
            v-model="formData.sans_beyane_price"
            type="text"
            placeholder=""
            class="form-control text-right col-lg-8 pr-3 pl-2 pr-2"
          />
        </div>

        <div
          :class="{
            'p-list-representation-error': $v.formData.system_porsant.$error
          }"
          class="d-flex align-items-center mb-4  p-edit-representation-form-item"
        >
          <label
            class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text"
          >
            پورسانت سیستم
          </label>
          <input
            v-model="formData.system_porsant"
            type="text"
            placeholder=""
            class="form-control text-right col-lg-8 pr-3 pl-2 pr-2"
          />
        </div>

        <div
          class="d-flex align-items-center mb-4  p-edit-representation-form-item"
        >
          <label
            class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text"
          >
            تیپ های موجود
          </label>

          <multiselect
            v-model="formData.using_type"
            :options="usingType"
            tag-placeholder="Add this as new tag"
            placeholder="Search or add a tag"
            :multiple="true"
          ></multiselect>

        </div>
      </div>

      <div class="row w-100 mt-0 mt-lg-2">
        <selectedPic
          @updateImg="picOWenPermission"
          text="تصویر مالکیت یا اجاره نامه"
          :form-pic="formData"
          pic-property="ownership_or_rent_image"
        ></selectedPic>

        <selectedPic
          @updateImg="picContract"
          text="تصویر قرداد"
          :form-pic="formData"
          pic-property="contract_image"
        ></selectedPic>
      </div>

      <div class="w-100 row mb-5">
        <div
          class="w-100 d-flex flex-wrap p-list-representation-province-data-item mt-4 mb-4"
        >
          <div class="row p-salon-map-item ml-3 align-items-center">
            <h3 class="p-salon-map-item-title">نام سالن:</h3>
            <h3 class="p-salon-map-item-title mr-1">{{ formData.name }}</h3>
          </div>
          <div class="row p-salon-map-item ml-3 align-items-center">
            <h3 class="p-salon-map-item-title">نام صاحب سالن:</h3>
            <h3 class="p-salon-map-item-title  mr-1">
              {{ formData.club.name }}
            </h3>
            <h3 class="p-salon-map-item-title  mr-1">
              {{ formData.club.family }}
            </h3>
          </div>
        </div>
        <mapSalon
          :form-data="formDataOriginal"
          @changeLocation="changeLocation"
        ></mapSalon>
      </div>

      <div
        class="flex-column justify-content-center w-100 p-list-salon-owner-export-btns d-flex flex-lg-row mb-5"
      >
        <button
          type="submit"
          class="p-list-representation-btn btn btn-primary btn-sm  mr-0 mr-lg-4 btn-blue"
        >
          ثبت/ویرایش
        </button>

        <!-- <button @click="editAndEntrySalons" type="button" class="p-list-representation-btn btn btn-primary btn-sm  mr-0 mr-lg-4 btn-blue">
              ویرایش موقعیت مکانی
            </button> -->
      </div>
    </form>
  </div>
</template>

<script>
import typeUser from "./typeUser";
import toolsSalon from "./toolsSalon";
import selectedPic from "./selectedPic";
import { required, numeric } from "vuelidate/lib/validators";
import mapSalon from "./mapSalon";

export default {
  name: "formData",
  components: {
    typeUser,
    toolsSalon,
    selectedPic,
    mapSalon
  },

  props: {
    excelData: { type: Array, default: [] },
    nameFamilySalondar: { type: Array, default: [] },
    selectedNameFamilySalondar: { type: Object, default: {} },
    formDataOriginal: { type: Object, default: {} },
    allEnums: { type: [Object, Array], default: {} }
  },

  data() {
    return {
      formData: {
        club: {}
      },
      usingType: []
    };
  },

  validations: {
    formData: {
      club: {
        bank_name: {},
        name: {
          required
        },
        family: {
          required
        }
      },
      name: {
        required
      },
      address: {
        required
      },
      shaba_code: {
        numeric,
        correctShabaCode(value) {
          const checkTypeValue = /^\d+$/.test(value);

          if (checkTypeValue) {
            if (value.length == 24) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      },
      phone: {
        numeric
      },
      content: {
        required
      },
      sans_price: {
        required
      },
      sans_beyane_price: {
        required
      },
      system_porsant: {
        required
      }
    }
  },

  computed: {},

  mounted() {
    this.formData = this.formDataOriginal;
    this.defaultSelectedSalondar();

    console.log(this.formData, 'formData');
    this.usingType = this.usingTypeForMultiselect(this.allEnums.using_type);
  },

  watch: {},

  methods: {
    editAndEntrySalons() {
      this.$router.push({ name: "mapLocation" });
    },

    usingTypeForMultiselect(usingType) {
      for (let key in usingType) {
        this.usingType.push(key);
      }

      return this.usingType;
    },

    defaultSelectedSalondar() {
      const selectedNameFamilySalondar = this.selectedNameFamilySalondar;
      this.formData.valueSelectedNameFamilySalondar = selectedNameFamilySalondar;
    },

    submit() {
      this.$v.$touch();

      this.$emit("submitData", this.formData);

      // if (this.$v.$invalid) {
      //   window.scrollTo(0, 0);
      //   this.$message.error("لطفا اطلاعات خود را بررسی کنید");
      // } else {
      //   this.$emit("submitData", this.formData);
      // }
    },

    picOWenPermission(blob) {
      this.formData.ownership_or_rent_image = blob;
    },

    picContract(blob) {
      this.formData.contract_image = blob;
    },

    changeTools(current, allData, selectedCheckBox) {
      this.formData.facilities = selectedCheckBox;
    },

    changeType(current, allData, selectedCheckBox) {
      this.formData.using_type = selectedCheckBox;
      this.formData.ball_type = selectedCheckBox;
    },

    initialConvertArrayFacilities(data) {
      this.formData.facilities = data;
    },

    initialConvertArrayUsingType(data) {
      this.formData.using_type = data;

      this.formData.ball_type = data;
    },

    changeLocation(data) {
      this.formData.lat = data.lat;
      this.formData.lng = data.lng;
    }
  }
};
</script>
